"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _DateFormatter = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/util/DateFormatter"));

var _ServiceException = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/exception/ServiceException"));

var _Console = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/Console"));

var _TotalPriceModel = _interopRequireDefault(require("../model/TotalPriceModel"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Handles formatting of prices.
 *
 * Deprecated, use @ikea-aoa/ikea-shared-utils/lib/util/PriceFormatter
 */
var TotalPriceCalculator = /*#__PURE__*/function () {
  function TotalPriceCalculator() {
    _classCallCheck(this, TotalPriceCalculator);
  }

  _createClass(TotalPriceCalculator, null, [{
    key: "calculate",

    /**
     * Calculates total price.
     *
     * @throws Exception
     * @param {object[]} items Array of items.
     * @param {object[]} articles Array of articles.
     * @param {string} dateFormat Date format.
     * @returns {TotalPriceModel} Instance of TotalPriceModel.
     */
    value: function calculate(items, articles, dateFormat) {
      var totalPrice = new _TotalPriceModel.default();
      var validDates = [];

      var itemsMap = this._getItemsMap(items);

      if (items.length === 0) {
        totalPrice.isNew = false;
      }

      for (var i = 0, max = articles.length; i < max; i++) {
        var article = articles[i];
        var item = itemsMap[article.GlobalID] || itemsMap[article.LocalID];

        if (item) {
          var familyValidDate = this._calculateFamilyPrice(item, article, totalPrice);

          var troValidDate = this._calculateTroPrice(article, totalPrice);

          this._calculateNormalPrice(item, article, totalPrice);

          this._calculateRegularPrice(item, article, totalPrice);

          this._calculateFeePrices(item, article, totalPrice);

          totalPrice.isOnlineSellable = article.isOnlineSellable === false ? false : totalPrice.isOnlineSellable;
          totalPrice.isNew = article.isNew === false ? false : totalPrice.isNew;

          if (familyValidDate) {
            validDates.push(familyValidDate);
          }

          if (troValidDate) {
            validDates.push(troValidDate);
          }
        } else {
          throw new _ServiceException.default('Failed to calculate total price. Missing the following articles in the response: ' + article.GlobalID + '. Also make sure that it is not a duplicate.', 'TotalPriceCalculator');
        }
      }

      totalPrice.validDateInterval = this._getValidDateInterval(validDates, dateFormat); // TODO: Remove deprecated property "validDates".

      Object.defineProperty(totalPrice, 'validDates', {
        get: function get() {
          _Console.default.warn('TotalPriceCalculator: The property "validDates" has been deprecated. Use "validDateInterval" instead.');

          return totalPrice.validDateInterval ? [totalPrice.validDateInterval] : [];
        }
      });
      return totalPrice;
    }
    /**
     * Returns a map with items.
     *
     * @param {object[]} items Item objects.
     * @returns {object} Items map.
     */

  }, {
    key: "_getItemsMap",
    value: function _getItemsMap(items) {
      var itemsMap = {};

      var _iterator = _createForOfIteratorHelper(items),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;

          if (typeof item.qty !== 'number' || isNaN(item.qty) || !item.type || !item.id) {
            throw new _ServiceException.default('Item is missing one of the following mandatory properties: qty, type or id', 'TotalPriceCalculator');
          }

          itemsMap[item.id] = item;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return itemsMap;
    }
    /**
     * Handles normal price.
     *
     * @param {object} item Item object.
     * @param {object} article Article object.
     * @param {TotalPriceModel} totalPrice Total price model.
     */

  }, {
    key: "_calculateNormalPrice",
    value: function _calculateNormalPrice(item, article, totalPrice) {
      var prices = article.Prices; // we should always have a normal price

      if (prices.NormalPrice) {
        totalPrice.normal += prices.NormalPrice.Price * item.qty;
        totalPrice.normalExclTax += prices.NormalPrice.PriceExclTax * item.qty;
      } else if (prices.RegularPrice) {
        totalPrice.normal += prices.RegularPrice.Price * item.qty;
        totalPrice.normalExclTax += prices.RegularPrice.PriceExclTax * item.qty;
      } else {
        throw new _ServiceException.default('Failed to calculate total price. Missing valid normal price in item: ' + Array.from(item.keys()).join(', ') + '.', 'TotalPriceCalculator');
      }
    }
    /**
     * Handles family prices.
     *
     * @param {object} item Item object.
     * @param {object} article Article object.
     * @param {TotalPriceModel} totalPrice Total price model.
     * @returns {object} Valid date.
     */

  }, {
    key: "_calculateFamilyPrice",
    value: function _calculateFamilyPrice(item, article, totalPrice) {
      var prices = article.Prices;

      if (article.isFamilyPrice) {
        totalPrice.isFamily = true;
        totalPrice.family += prices.FamilyPrice.Price * item.qty;
        totalPrice.familyExclTax += prices.FamilyPrice.PriceExclTax * item.qty;
      } else {
        // if this was not a family product, family price increases with normal price
        totalPrice.family += prices.NormalPrice.Price * item.qty;
        totalPrice.familyExclTax += prices.NormalPrice.PriceExclTax * item.qty;
      }

      if (article.isTemporaryFamilyPrice) {
        totalPrice.isTemporary = true;
        return {
          validFrom: _DateFormatter.default.isoStringToDate(prices.FamilyPrice.ValidFrom),
          validTo: _DateFormatter.default.isoStringToDate(prices.FamilyPrice.ValidTo)
        };
      }

      return null;
    }
    /**
     * Handles TRO price.
     *
     * @param {object} article Article object.
     * @param {TotalPriceModel} totalPrice Total price model.
     * @returns {object} Valid date.
     */

  }, {
    key: "_calculateTroPrice",
    value: function _calculateTroPrice(article, totalPrice) {
      var prices = article.Prices;

      if (article.isTimeRestrictedOffer) {
        totalPrice.isTemporary = true;
        return {
          validFrom: _DateFormatter.default.isoStringToDate(prices.NormalPrice.ValidFrom),
          validTo: _DateFormatter.default.isoStringToDate(prices.NormalPrice.ValidTo)
        };
      }

      return null;
    }
    /**
     * Handles Regular price.
     *
     * @param {object} item Item object.
     * @param {object} article Article object.
     * @param {TotalPriceModel} totalPrice Total price model.
     */

  }, {
    key: "_calculateRegularPrice",
    value: function _calculateRegularPrice(item, article, totalPrice) {
      var prices = article.Prices;

      if (prices.RegularPrice && !article.isNewLowerPrice) {
        totalPrice.regular += prices.RegularPrice.Price * item.qty;
        totalPrice.regularExclTax += prices.RegularPrice.PriceExclTax * item.qty;
      } else {
        // if we don't have a special regular price, then the normal is regular
        totalPrice.regular += prices.NormalPrice.Price * item.qty;
        totalPrice.regularExclTax += prices.NormalPrice.PriceExclTax * item.qty;
      }
    }
    /**
     * Handles fee prices.
     *
     * @param {object} item Item object.
     * @param {object} article Article object.
     * @param {TotalPriceModel} totalPrice Total price model.
     */

  }, {
    key: "_calculateFeePrices",
    value: function _calculateFeePrices(item, article, totalPrice) {
      var _iterator2 = _createForOfIteratorHelper(article.ItemFees),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var fee = _step2.value;

          if (fee.Type === 'ECO') {
            totalPrice.ecoPrice += Number(fee.Amount * item.qty);
          } else if (fee.Type === 'WEEE') {
            totalPrice.weeePrice += Number(fee.Amount * item.qty);
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
    /**
     * Merges the dates inte one single valid date.
     *
     * @param {object[]} validDates Valid dates.
     * @param {string} dateFormat Pattern to use.
     * @returns {object} The merged date.
     */

  }, {
    key: "_getValidDateInterval",
    value: function _getValidDateInterval(validDates, dateFormat) {
      if (validDates.length > 0) {
        var validDate = validDates[0];
        var date = {
          validFrom: validDate.validFrom,
          validTo: validDate.validTo
        };

        var _iterator3 = _createForOfIteratorHelper(validDates),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var _validDate = _step3.value;

            if (_validDate.validFrom > date.validFrom) {
              date.validFrom = _validDate.validFrom;
            }

            if (_validDate.validTo < date.validTo) {
              date.validTo = _validDate.validTo;
            }
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }

        return {
          validFrom: _DateFormatter.default.dateToString(date.validFrom, dateFormat),
          validTo: _DateFormatter.default.dateToString(date.validTo, dateFormat)
        };
      }

      return null;
    }
  }]);

  return TotalPriceCalculator;
}();

exports.default = TotalPriceCalculator;